import { DateTime, Settings } from 'luxon';

export const humanizeDate = (date: string, timezone?: string): string => {
  const luxonDate = DateTime.fromISO(date, { zone: timezone ?? Settings.defaultZone });
  const currentDay = DateTime.fromObject({
    hour: 0,
    minute: 0,
    second: 0,
    zone: timezone ?? Settings.defaultZone,
  });
  const { days } = luxonDate.startOf('day').diff(currentDay, 'days');
  const showYear = luxonDate.year !== currentDay.year;

  let dayName = luxonDate.weekdayLong;

  if (luxonDate.hasSame(currentDay, 'day')) {
    dayName = 'Today';
  } else if (days === 1) {
    dayName = 'Tomorrow';
  }

  const formattedDate = luxonDate.toFormat(`LLL d${showYear ? ', y' : ''}`);
  return `${dayName}, ${formattedDate}`;
};
